export const EventsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M3 12h4l3 8 4-16 3 8h4"></path>
    </svg>
  );
};
